// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules___Uhql","more":"styles_more__rUpEc"};